import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/** Validates a selected GraphQL value; the callback preserves type inference. */
export function passThroughAndValidateNotNull<T>() {
  return graphql.transformers.OUT.validate<T, NonNullable<T>>(
    transformers.PASS_THROUGH,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  )
}

/** Extracts a GraphQL `info` field; the callback preserves type inference. */
export function extractFromInfo<T, K extends Key.In.Union<T>>(key: K) {
  return {
    usingFullInput: graphql.transformers.OUT.select<
      { info: T },
      NonNullable<IndexUnion<T, K>>,
      'info'
    >('info', graphql.transformers.OUT.select(key, transformers.PASS_THROUGH)),
  }
}

/** Extracts and validates a required GraphQL `info` field. */
export function extractFromInfoAndValidateNotNull<T, K extends Key.In.Union<T>>(
  key: K,
) {
  return {
    usingFullInput: graphql.transformers.OUT.validate(
      extractFromInfo<T, K>(key).usingFullInput,
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
  }
}

/** Extracts a GraphQL `info` field with a fallback value. */
export function extractFromInfoWithDefault<T, K extends Key.In.Union<T>, D>(
  key: K,
  _default: D,
) {
  return {
    usingFullInput: graphql.transformers.OUT.default(
      extractFromInfo<T, K>(key).usingFullInput,
      _default,
    ),
  }
}
